const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Explorer Grid Directive which displays and handles loading and infinite scrolling for content-tiles
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {explorer} Explorer injected to gain access to the explorer resource
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {$q} $q Angular's propmise library
 * @argument {$rootScope} $rootScope Root Scope accessing service
 */
app.directive('explorerGrid', ['Application', 'Authorization', 'explorer', 'Analyze', '$location', '$q', '$translate', function (Application, Authorization, Explorer, Analyze, $location, $q, $translate) {
    return {
      restrict: 'E',
      scope: {
        loadingIndicator: '=',
        chosenCategory: '=',
        active: '=',
        searchQueries: '=',
        clearSearch: '='
      },
      template: require('../../templates/directives/explorer-grid.html'),
      controller: ['$scope', '$window', function ($scope, $window) {
          var self = this;
          self.user = Authorization.getAuthToken().user;
          self.meta = {};
          self.initialLoad = false;
          self.exiting = false;

          self.isListView = Application.features.flags().explore_in_list_view;
          self.loadArr = self.isListView ? [1,2,3,4,5,6,7,8,9,10,11] : [1,2,3,4,5];

          self.sortParameter = 'createdAt';
          self.sortOrder = -1;

          self.linked_category = null;

          self.searchTerm = '';
          self.contentTypes = '';

          Application.smartbar.searchText = '';
          self.smartbar = Application.smartbar;

          var getWindowHeight = function() {
            return Math.max(
              $window.innerHeight
            );
          };

          self.scrollOffset = 0;
          var calculateScrollableArea = function(){
            var getWindowOffset = setInterval(function(){
              var exploreTopbar = document.querySelector('explore-topbar');
              var mainTopbar = document.querySelector('.topbar');
              var offset = 0;
              if (document.readyState === 'complete' && exploreTopbar && mainTopbar && (exploreTopbar.clientHeight !== 0 || exploreTopbar.offsetHeight !== 0) && (mainTopbar.clientHeight !== 0 || mainTopbar.offsetHeight !== 0) ){
                offset = (exploreTopbar.clientHeight || exploreTopbar.offsetHeight) + (mainTopbar.clientHeight || mainTopbar.offsetHeight);
                self.windowHeight = getWindowHeight() - offset - 1;
                $scope.$apply();
                clearInterval(getWindowOffset);
              }
            },100);
          };
          calculateScrollableArea();
          setTimeout (function() {
            calculateScrollableArea();
          }, 100);
          angular.element($window).bind('resize', function() {
            calculateScrollableArea();
          });

          var refresh = function () {
            self.inSearch = false;
            self.queue = [];
            self.activeContent = [];
            self.disableScroll = true;
            self.endOfLine = false;
            self.perCall = self.isListView ? 15 : 11;
            self.query = {
              page: 1,
              per_page: self.perCall,
              sort: self.sortParameter + ',' + self.sortOrder,
              // These two are manipulated outside of the query handler in explore.search and explore.find
              privacy_locations: self.user.linked_locations ? self.user.linked_locations[0] : null,
              privacy_departments: self.user.linked_departments ? self.user.linked_departments[0] : null,
              privacy_teams: self.user.linked_teams && self.user.linked_teams.length > 0? self.user.linked_teams.join('|') : null,
              privacy_org_level: self.user.linked_org_level ? self.user.linked_org_level : null,
              privacy_grade: self.user.linked_grade ? self.user.linked_grade : null
            };

            if (self.linked_category) {
              self.query.linked_category = self.linked_category._id;
            }

            if (self.contentTypes) {
              self.query.restricted_types = self.contentTypes;
            }
            calculateScrollableArea();
          };

          var getContent = function() {
            if (self.inSearch) {
              Analyze.record({resource: 'search'}, {search_term: self.searchTerm})
              return Explorer.search(self.query).$promise.then(function(results) {
                var data = [];
                results.data.forEach(function(item) {
                  data = data.concat(item);
                });

                return {data: data, next_page: results.next_page || null};
              });
            }
            return Explorer.find(self.query).$promise;
          };

          self.getMeta = function(items) {
            var contentIds = [];

            angular.forEach(items, function(item) {
              if (!self.meta[item._id]) {
                contentIds.push(item._id);
              }
            });

            contentIds = contentIds.join(',');

            Analyze.explore({content: contentIds, subresource: 'count-items'}).$promise
            .then(function(data) {
              angular.forEach(data.data, function(item) {
                self.meta[item.contentId] = item;
              });
            }).catch(function(err) {
              console.log('Error getting card stats: ', err);
            });
          };

          var refillQueue = function () {
            var deferred = $q.defer();
            if (self.endOfLine || self.queue && self.queue.length && self.queue.length >= self.query.per_page) {
              deferred.resolve(self.queue);
              return deferred.promise;
            }

            getContent().then(function (body) {
              self.query.page = body.next_page;

              self.queue = self.queue.concat(body.data);

              if (!self.query.page) {
                self.endOfLine = true;
              }

              deferred.resolve();
            });

            return deferred.promise;
          };

          self.load = function () {
            self.disableScroll = true;
            refillQueue()
            .then(function () {
              if (!self.exiting) {
                if (self.linked_category && self.linked_category._id) {
                  $location.path('/explore/' + self.linked_category._id);
                } else {
                  $location.path('/explore');
                }
  
                self.initialLoad = true;
                self.getMeta(self.queue.slice(0, self.perCall));
                self.activeContent = self.activeContent.concat(self.queue.splice(0, self.perCall));
                if (!self.endOfLine || (self.queue && self.queue.length)) {
                  self.disableScroll = false;
                }
              }
            });
          };

          self.initialize = function () {
            Application.smartbar.setPlaceholder(self.translations["explore.general.search_placeholder"] );
            Application.smartbar.showCategories();
            Application.smartbar.showSearch();
          };

          $scope.$on('$destroy', function () {
            angular.element($window).unbind('resize');
            Application.smartbar.searchText = '';
            Application.smartbar.hideSearch();
            // Cancel any existing loading/navigation.
            self.exiting = true;
          });

          var onSearch = function (term, types) {
            refresh();
            self.inSearch = true;
            self.query.searchTerm = self.searchTerm;
            delete self.query.sort;
            delete self.query.linked_category;
            self.load();
          };

          $scope.$watch('chosenCategory', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue && (newValue._id || newValue === 'empty_external')) {
              if (!$scope.active || $scope.active !== 'content') {
                return;
              }
              if (newValue !== 'empty_external') {
                self.linked_category = newValue;
              }
              if (self.searchTerm) {
                $scope.clearSearch = true;
              }
              refresh();
              self.load();
            }
          });

          var onActive = function() {
            self.linked_category = $scope.chosenCategory;
            refresh();
            self.inSearch = false;
            self.load();
          }

          $scope.$watch('active', function (newValue, oldValue) {
            if (newValue === 'content' && newValue !== oldValue) {
              onActive();
            }
          });

          $translate(['explore.general.search_placeholder']).then(function(translations){
            self.translations = translations;
            self.initialize();
          });


        //IOS fix
        function iOSVersion() {
          if(window.MSStream){
            return false;
          }
          var match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/),
            version;

          if (match !== undefined && match !== null) {
            version = [
              parseInt(match[1], 10),
              parseInt(match[2], 10),
              parseInt(match[3] || 0, 10)
            ];
            return parseFloat(version.join('.'));
          }

          return false;
        };
        var ver = iOSVersion();
        self.iconCheck = function(){
          if (ver > 8.9 && ver < 9.9){
            var icons = document.querySelectorAll('.smartcard__content--poll__options--icons');
            var i;
            if(icons.length){
              for (i = 0; i < icons.length; ++i) {
                icons[i].classList.add('ios');
              }
            } else {
              console.log('no wrappers');
            }
          };
        };

        var typeMap = {
          article: 'articles',
          workshop: 'workshops',
          video: 'videos',
          file: 'files',
          track: 'tracks',
          course: 'scorm,tracks,imported_content',
          scorm: 'scorm'
        };

        $scope.$watch('searchQueries', function(newVal, oldVal) {
          if (newVal.length) {
            var searchTerm;
            var contentTypes = '';
            newVal.forEach(function(item) {
              if (item.type === 'text') {
                searchTerm = item.name;
                return;
              }
              if (!typeMap[item.type]) {
                return;
              }
              contentTypes += typeMap[item.type] + ','
            });
            if (contentTypes.length) {
              contentTypes = contentTypes.slice(0, -1)
            }

            self.inSearch = false;
            if (self.searchTerm !== searchTerm || self.contentTypes !== contentTypes) {
              self.searchTerm = searchTerm;
              self.contentTypes = contentTypes;

              if (self.searchTerm) {
                onSearch();
                return;
              }
              onActive();
              return;
            }
          }
          if (oldVal.length) {
            self.searchTerm = '';
            self.contentTypes = '';
            onActive();
          }
        }, true);
      }],
      controllerAs: 'explorer'
    };
  }]);
